import { userQueryKeys } from './userQueryKeys.js';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { getBrowserClientTimeZone } from '../utils/getBrowserClientTimeZone.js';
import { useWoody } from '../../woody/woody.js';
import { useAuthStatus } from '@fabric-app/compat';

const useQueryUserPreferences = (queryOptions) => {
  const { client } = useWoody();
  const authstatus = useAuthStatus();
  return useQuery({
    queryKey: userQueryKeys.userPreferences(),
    queryFn: async () => {
      const data = await client.v2("/v2/user/preferences");
      if (!data || !data.timezone) {
        try {
          const currentBrowserTimezone = getBrowserClientTimeZone();
          await client.v2("/v2/user/preferences", {
            method: "put",
            body: {
              timezone: currentBrowserTimezone ?? null
            }
          });
          return {
            ...data,
            timezone: currentBrowserTimezone
          };
        } catch {
        }
      }
      return data ?? {
        timezone: void 0,
        frontend: {}
      };
    },
    placeholderData: keepPreviousData,
    enabled: authstatus === "authenticated",
    ...queryOptions
  });
};

export { useQueryUserPreferences };
//# sourceMappingURL=useQueryUserPreferences.js.map
